import { useTranslation } from 'react-i18next';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { TechnicalUserStatus } from '../hooks/useTechnicalUser';
import LoadingIndicator from '../../../components/loading/LoadingIndicator';
import {
  SectionContainer,
  DetailsGrid,
  DetailsTitle,
  DetailsValue,
  SectionLeftColumn,
  SectionRightColumn,
  InfoHeader,
} from './layoutComponents';
import UserNameField from './UserNameField';

interface Props {
  technicalUser?: UserDetailsDto;
  technicalUserStatus: TechnicalUserStatus;
  firstName: string;
  setFirstName: (firstName: string) => void;
  lastName: string;
  setLastName: (lastName: string) => void;
}

const TechnicalUserDetails = ({
  technicalUser,
  technicalUserStatus,
  firstName,
  setFirstName,
  lastName,
  setLastName,
}: Props) => {
  const { t } = useTranslation('onsite');

  if (technicalUserStatus === 'INITIALIZING') {
    return (
      <SectionContainer>
        <LoadingIndicator />
      </SectionContainer>
    );
  }

  if (technicalUserStatus === 'NOT_FOUND') {
    return (
      <SectionContainer>
        <InfoHeader>{t('technical-user.not-found')}</InfoHeader>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer>
      <SectionLeftColumn>
        <DetailsGrid>
          <DetailsTitle>{`${t('technical-user.user-id')}:`}</DetailsTitle>
          <DetailsValue>{technicalUser?.id}</DetailsValue>
          <DetailsTitle>{`${t('technical-user.first-name')}:`}</DetailsTitle>
          <UserNameField value={firstName} onChange={setFirstName} />
          <DetailsTitle>{`${t('technical-user.last-name')}:`}</DetailsTitle>
          <UserNameField value={lastName} onChange={setLastName} />
        </DetailsGrid>
      </SectionLeftColumn>
      <SectionRightColumn></SectionRightColumn>
    </SectionContainer>
  );
};

export default TechnicalUserDetails;
